// extracted by mini-css-extract-plugin
module.exports = {"vimeo":"ProgramDetails_vimeo__1MPBT"};